import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const BaseChips = styled(motion.div)<{
	selected: boolean;
	disabled: boolean;
}>`
	width: max-content;
	white-space: nowrap;
	height: 32px;
	border-radius: 8px;
	padding: 0 16px;

	${({ theme }) => theme.typo.body.p_bold};
	${({ theme }) => theme.common.flexCenter};

	position: relative;
	transition: background-color 0.2s linear, color 0.2s linear;
	cursor: pointer;

	color: ${({ theme }) => theme.colors.gray.gray80_text};
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	// hover
	&:hover {
		color: ${({ theme }) => theme.colors.gray.gray80_text};
		background-color: ${({ theme }) => theme.colors.gray.gray10};
		border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	}
	// pressed
	/* &:active {
		color: ${({ theme }) => theme.colors.gray.gray80_text};
		background-color: ${({ theme }) => theme.colors.gray.gray15};
		border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	} */
	// active
	${({ selected }) =>
		selected &&
		css`
			color: ${({ theme }) => theme.colors.gray.gray_white};
			background-color: ${({ theme }) => theme.colors.gray.gray_black};

			/* TODO 투두: 색상 변경 해야함. */
			&:hover {
				color: ${({ theme }) => theme.colors.uplus.bg30};
				background-color: #51575c;
				border: 1px solid ${({ theme }) => theme.colors.uplus.bg15};
			}
		`}
	// disabled
    ${({ disabled }) =>
		disabled &&
		css`
			color: ${({ theme }) => theme.colors.gray.gray30};
			background-color: ${({ theme }) => theme.colors.uplus.bg15};
			border: 1px solid ${({ theme }) => theme.colors.uplus.bg15};
			cursor: default;
			& > div > span > svg {
				fill: ${({ theme }) => theme.colors.uplus.bg30};
			}

			&:hover {
				color: ${({ theme }) => theme.colors.uplus.bg30};
				background-color: ${({ theme }) => theme.colors.uplus.bg15};
				border: 1px solid ${({ theme }) => theme.colors.uplus.bg15};
				cursor: default;
				& > div > span > svg {
					fill: ${({ theme }) => theme.colors.uplus.bg30};
				}
			}
		`}
`;

// Assist
export const AssistChips = styled(BaseChips)`
	padding: 0 8px 0 4px;
`;

export const ProfileWrapper = styled.div`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	overflow: hidden;
	margin-right: 8px;
`;

export const DropdownIconWrapper = styled.div<{ chips_clicked: boolean }>`
	width: 18px;
	height: 18px;
	margin-left: 8px;
	& > span {
		width: 100%;
		height: 100%;
		transition: 0.2s;

		transform: ${(props) => (props.chips_clicked ? 'rotate(180deg)' : 'rotate(0deg)')};
	}
`;

export const ProfilePicture = styled.div<{ picture: string }>`
	width: 100%;
	height: 100%;

	background-image: url(${({ picture }) => picture});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
`;

export const OptionList = styled.ul`
	width: 100%;
	min-width: 240px;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray.gray15};
	border-radius: 8px;
	box-shadow: ${(props) => props.theme.shadow.depth04};

	position: absolute;
	left: 0;
	top: 36px;
	z-index: 2;
`;

export const OptionItem = styled.li`
	width: 100%;
	height: 48px;
	padding: 10px 0 10px 16px;
	margin: 8px 0;

	color: ${(props) => props.theme.colors.gray.gray80_text};
	font-size: ${(props) => props.theme.font.size.p};
	font-weight: ${(props) => props.theme.font.weight.regular};

	display: flex;
	align-items: center;
	cursor: pointer;

	&:hover {
		background-color: ${(props) => props.theme.colors.gray.gray05_bg};
	}
`;

// Default
export const FilterDefaultChips = styled(BaseChips)`
	${({ selected }) => selected && 'padding: 0 16px 0 8px;'}
`;

//Gray
export const FilterGrayChips = styled(BaseChips)`
	${({ selected }) =>
		selected &&
		css`
			color: ${({ theme }) => theme.colors.gray.gray_white};
			background-color: ${({ theme }) => theme.colors.gray.gray80_text};
			border: 1px solid ${({ theme }) => theme.colors.gray.gray80_text};

			&:hover {
				color: ${({ theme }) => theme.colors.gray.gray_white};
				background-color: ${({ theme }) => theme.colors.gray.gray_black};
				border: 1px solid ${({ theme }) => theme.colors.gray.gray_black};
			}
		`}
`;

export const FilterLargeChips = styled(FilterDefaultChips)<{
	_width?: string;
	flex?: 'start' | 'center' | 'end';
}>`
	${({ _width }) => _width && `width: ${_width}`};
	height: 56px;
	flex-grow: 1;

	${({ flex, theme }) =>
		flex === 'start'
			? theme.common.flexStart
			: flex === 'center'
			? theme.common.flexCenter
			: flex === 'end'
			? theme.common.flexEnd
			: ''};
`;

// Close
export const FilterWithClose = styled(motion.div)`
	width: max-content;
	white-space: nowrap;
	height: 32px;
	border-radius: 8px;
	padding: 0 8px 0 16px;
	font-size: ${({ theme }) => theme.font.size.p};
	font-weight: ${({ theme }) => theme.font.weight.bold};
	${({ theme }) => theme.common.flexCenter};

	color: ${({ theme }) => theme.colors.primary.primary80_darken};
	background-color: ${({ theme }) => theme.colors.primary.primary10_lighten};
	border: 1px solid ${({ theme }) => theme.colors.primary.primary10_lighten};
`;

export const LeftIconWrapper = styled.div`
	width: 18px;
	height: 18px;
	margin-right: 8px;
	& > span {
		width: 100%;
		height: 100%;
	}
`;

export const DeleteIconWrapper = styled.div`
	width: 18px;
	height: 18px;
	margin-left: 8px;
	& > span {
		width: 100%;
		height: 100%;
	}
	cursor: pointer;
`;

// Group
export const ChipsCarouselGroup = styled(motion.div)<{
	_width: string;
	draggable: boolean;
}>`
	width: ${({ _width }) => _width};
	overflow: hidden;
	/* cursor: ${({ draggable }) => !draggable && 'grab'}; */
`;

export const ChipsCarouselGroupInner = styled(motion.div)`
	display: flex;

	& > div {
		margin-right: 8px;
	}
	& > div:last-of-type {
		margin-right: 16px;
	}
`;

export const ChipsGroup = styled.div<{
	_width: string;
	group_type?: 'multi_line' | 'carousel';
}>`
	width: ${({ _width }) => _width};
	display: flex;
	flex-wrap: wrap;
	& > div {
		margin: ${({ group_type }) =>
			group_type === 'multi_line' ? `8px 8px 8px 0` : `margin: 4px 8px 4px 0`};
	}
	& > div:last-of-type {
		margin-right: 16px;
	}
`;

export const ChipsLargeGroup = styled(ChipsGroup)`
	flex-wrap: nowrap;
	& > div {
		margin: 0 8px 0 0;
	}
	& > div:last-of-type {
		margin-right: 0px;
	}
`;
